// extracted by mini-css-extract-plugin
module.exports = {"root":"BackToFactFile_root__AQ1H5","star":"BackToFactFile_star__ccouP","left":"BackToFactFile_left__Jmgy0","right":"BackToFactFile_right__2_7x0"};